export function cutString(text, len) {
  let limit =  len || 50;
  if(text && typeof(text) === "string")
    return text.length < limit ? text : `${text.substr(0, limit - 1)}...`;
  return text
}

export function replaceWithSymbol(string,symbol="-"){
	if(string)
		return string.replace(/ /g,symbol)
	return ""
}


// WEBPACK FOOTER //
// ./src/util/cutString.js